module.exports = __webpack_public_path__ + "img/IJR_Mudancas_Fretes_f3-300x300.37a1cdc9.webp";